export const none = 'var(--seed-scale-letter-spacing-none)';
export const narrow200 = 'var(--seed-scale-letter-spacing-narrow-200)';
export const narrow300 = 'var(--seed-scale-letter-spacing-narrow-300)';
export const narrow400 = 'var(--seed-scale-letter-spacing-narrow-400)';